import axios from "axios";
import tempLogo from "../../../../public/images/uploadLogo.png";

export default {
  getCompaniesAsAdmin() {
    return axios.get('/api/company/getcompaniesasadmin', {withCredentials: true});
  },

  allCountry() {
    return axios.get(
      `${process.env.VUE_APP_NOTIFIER_URL}/api/v0.1/countries/positions`,
      { withCredentials: true }
    );
  },
  getSector(_, params) {
    return axios.post("/api/sector/getsectors", params, {
      withCredentials: true,
    });
  },
  postCompany(_, params) {
    const requestBody = {
      plan_id: params.plan_id,
      company_name: params.company_name,
      company_fullname: params.company_fullname,
      website: params.website,
      company_email: params.company_email,
      company_phone: params.company_phone,
      adress: params.adress,
      add_country_id: params.add_country_id,
      add_state_id: params.add_state_id,
      add_province_id: params.add_province_id,
      description: params.description,
      sector_id: params.sector_id,
      created_by: params.created_by,
      total_employee_number: parseInt(params.total_employee_number),
      facility_number: params.facility_number,
      company_role: params.company_role,
      executive_code: params.executive_code,
    };

    if (params.white_label_code != null || params.white_label_code != undefined) {
      requestBody.white_label_code = params.white_label_code;
    }

    if (params.regular_company_code != null || params.regular_company_code != undefined) {
      requestBody.regular_company_code = params.regular_company_code;
    }

    return axios.post(
      `/api/company/registercompany/${params.role_id}`,
      requestBody,
      { withCredentials: true }
    );
  },
  deleteCompany(_, params) {
    return axios.post("/api/company/deletecompany", params, {
      withCredentials: true,
    });
  },
  updateCompany(_, params) {
    const company_id = params.company_id;
    return axios.post(`/api/company/updatecompany/${company_id}`, params.body, {
      withCredentials: true,
    });
  },
  updateSection1(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        updated_by: params.updated_by,
        role_id: params.role_id,

        company_name: params.company_name,
        company_fullname: params.company_fullname,
        adress: params.adress,
        district: params.district,
        province: params.province,
        country: params.country,
      },
      { withCredentials: true }
    );
  },
  updateSection2(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        updated_by: params.updated_by,
        role_id: params.role_id,

        sector_id: params.selectedSector,
        sust_email: params.sust_email,
        sust_website: params.sust_website,
        total_employee_number: params.total_employee_number,
        currency_id: params.currency_id,
        website: params.website,
        company_phone: params.company_phone,
        company_email: params.company_email,
      },
      { withCredentials: true }
    );
  },
  updateDescription(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        description: params.description,
      },
      { withCredentials: true }
    );
  },
  getCompanyInfo(_, params) {
    return axios.post("/api/company/getcompanyinfo", params, {
      withCredentials: true,
    });
  },
  getCurrencies(_, params) {
    return axios.post("/api/currency/getcurrencies", params, {withCredentials: true});
  },

  updateLogo(_, params) {
    return axios.post("/api/company/uploadcompanylogo", params, { withCredentials: true });
  },

  getCompanyLogo(_, params) {
    return axios.post("/api/company/getcompanylogo", params, {
      responseType: "blob",
      withCredentials: true,
    });
  },

  // Returns { is_supplier: boolean } based on whether the caller's company has any
  // active company_codes row with supplier_code != 0.
  checkIsSupplier() {
    return axios.get("/api/companycode/is-supplier", { withCredentials: true });
  },
  getOrganizationChart(_, params) {
    return axios.post("/api/company/getcompanyorganizationchart", params, {
      responseType: "blob",
      withCredentials: true,
    });
  },


  /**
   * @typedef GetSetCompanyLogo
   * @property {number} company_id
   * @property {any} logo
   */
  /**
   * 
   * @param {*} param0 
   * @param {GetSetCompanyLogo} params 
   */
  async getAndSetCompanyLogo({ commit }, params) {
    if (params.logo) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(params.logo);
      fileReader.onloadend = function() {
        commit("SET_COMPANY_LOGO", fileReader.result);
      }
    } else if (params.company_id) {
      const body = { logo_link: `./uploads/${params.company_id}/logo/logo.png` };
      await axios.post(`/api/company/getcompanylogo`, body, { responseType: 'blob', withCredentials: false })
        .then(async (res) => {
          const blob = res.data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onloadend = function() {
            commit("SET_COMPANY_LOGO", fileReader.result);
          }
        })
        .catch(() => {
          commit("SET_COMPANY_LOGO", tempLogo );
        })
    }
  },

  //#region Facilities

  getFacilities(_, params) {
    return axios.post("/api/facility/getfacilitiesbycompanyid", params, {
      withCredentials: true,
    });
  },
  createFacility(_, params) {
    return axios.post("/api/facility/createfacility", params, {
      withCredentials: true,
    });
  },
  updateFacility(_, params) {
    return axios.post(
      `/api/facility/updatefacility/${params.facility_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteFacility(_, params) {
    return axios.post("/api/facility/deletefacility", params, {
      withCredentials: true,
    });
  },

  //#endregion

  //#region Vision, Mission & Values

  updateVision(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        vision: params.vision,
      },
      { withCredentials: true }
    );
  },
  updateMission(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        mission: params.mission,
      },
      { withCredentials: true }
    );
  },
  updateValues(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        values: params.values,
      },
      { withCredentials: true }
    );
  },

  //#endregion

  //#region Milestones

  createMilestones(_, params) {
    return axios.post("/api/milestone/createmilestone", params, {
      withCredentials: true,
    });
  },
  getMilestones(_, params) {
    return axios.post("/api/milestone/getmilestonesbycompanyid", params, {
      withCredentials: true,
    });
  },
  updateMilestones(_, params) {
    return axios.post(
      `/api/milestone/updatemilestone/${params.milestone_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteMilestones(_, params) {
    return axios.post("/api/milestone/deletemilestone", params, {
      withCredentials: true,
    });
  },

  //#endregion

  //#region Products

  getProducts(_, params) {
    return axios.post("/api/productgroup/getproductgroupsbycompanyid", params, {
      withCredentials: true,
    });
  },
  createProducts(_, params) {
    return axios.post("/api/productgroup/createproductgroup", params, {
      withCredentials: true,
    });
  },
  updateProduct(_, params) {
    return axios.post(
      `/api/productgroup/updateproductgroup/${params.product_group_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteProduct(_, params) {
    return axios.post("/api/productgroup/deleteproductgroup", params, {
      withCredentials: true,
    });
  },

  //#endregion

  //#region Dev. Networks

  getDevNetworks(_, params) {
    return axios.post(
      "/api/developmentnetwork/getcompanydevelopmentnetworksbycompanyid",
      params,
      { withCredentials: true }
    );
  },
  createDevNetworks(_, params) {
    return axios.post(
      "/api/developmentnetwork/createcompanydevelopmentnetwork",
      params,
      { withCredentials: true }
    );
  },
  updateDevNetwork(_, params) {
    return axios.post(
      `/api/developmentnetwork/updatecompanydevelopmentnetwork/${params.company_development_network_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteDevNetwork(_, params) {
    return axios.post(
      "/api/developmentnetwork/deletecompanydevelopmentnetwork",
      params,
      { withCredentials: true }
    );
  },
  getDefaultNetworks(_, params) {
    return axios.post(
      "/api/developmentnetwork/getdevelopmentnetworks",
      params,
      { withCredentials: true }
    );
  },

  //#endregion

  //#region Memberships

  getMemberships(_, params) {
    return axios.post(
      "/api/companymembership/getcompanymembershipsbycompanyid",
      params,
      { withCredentials: true }
    );
  },
  createMemberships(_, params) {
    return axios.post(
      "/api/companymembership/createcompanymembership",
      params,
      { withCredentials: true }
    );
  },
  updateMembership(_, params) {
    return axios.post(
      `/api/companymembership/updatecompanymembership/${params.company_membership_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteMembership(_, params) {
    return axios.post(
      "/api/companymembership/deletecompanymembership",
      params,
      { withCredentials: true }
    );
  },

  //#endregion

  //#region Awards

  getAwards(_, params) {
    return axios.post("/api/award/getawardsbycompanyid", params, {
      withCredentials: true,
    });
  },
  createAwards(_, params) {
    return axios.post("/api/award/createaward", params, {
      withCredentials: true,
    });
  },
  updateAward(_, params) {
    return axios.post(
      `/api/award/updateaward/${params.award_id}`,
      params.body,
      { withCredentials: true }
    );
  },
  deleteAward(_, params) {
    return axios.post("/api/award/deleteaward", params, {
      withCredentials: true,
    });
  },

  //#endregion

  //#region company codes

  getCompaniesCascade(_, params) {
    return axios.post("/api/company/getcompaniescascade", params, {
      withCredentials: true,
    });
  },

  getChildCompanies(_, params) {
    return axios.post("/api/company/get-child-companies", params, {
      withCredentials: true,
    });
  },

  getCompaniesToAddUnder(_, params) {
    return axios.post("/api/company/get-companies-to-add-under", params, {
      withCredentials: true,
    });
  },

  getCompaniesBelowRank(_, params) {
    return axios.post("/api/company/get-companies-below-rank", params, {
      withCredentials: true,
    });
  },

  createCompanyCode(_, params) {
    return axios.post("/api/companycode/createcompanycode", params, {
      withCredentials: true,
    });
  },

  deleteCompanyCode(_, params) {
    return axios.post("/api/companycode/deletecompanycode", params, {
      withCredentials: true,
    });
  },

  linkCompany(_, params) {
    return axios.post("/api/companycode/linkcompany", params, {
      withCredentials: true,
    });
  },

  acceptLinkCompany(_, params) {
    return axios.post("/api/companycode/acceptlinkinvitation", params, {
      withCredentials: true,
    });
  },

  getSustainfinityCode() {
    return axios.get("/api/companycode/getsustainfinitycodebycompanyid", { withCredentials: true }); 
  },
  
  getRelatedCompanies() {
    return axios.get("/api/companycode/get-related-companies", { withCredentials: true });
  },

  //#endregion

  //#region Sustainfinity Links

  getSustainfinityLinks() {
    return axios.get("/api/companycode/getsustainfinitylinks", {withCredentials: true});
  },

  getSustainfinityLinkById(_, params) {
    return axios.get(
      `/api/companycode/getsustainfinitylinkbyid/${params.sustainfinity_link_id}`,
      params,
      { withCredentials: true }
    );
  },

  createSustainfinityLink(_, params) {
    return axios.post("/api/companycode/createsustainfinitylink", params, {
      withCredentials: true,
    });
  },

  acceptSustainfinityLink(_, params) {
    return axios.post("/api/companycode/acceptlinkinvitation", params, {
      withCredentials: true,
    });
  },

  declineSustainfinityLink(_, params) {
    return axios.post("/api/companycode/declinelinkinvitation", params, {
      withCredentials: true,
    });
  },

  blockCompany(_, params) {
    return axios.post("/api/companycode/blockcompany", params, {
      withCredentials: true,
    });
  },

  // send mail with company code //

  sendExecutiveMail(_, params) {
    return axios.post("/api/auth/sendexecutiveregisteremail", params, {
      withCredentials: true,
    });
  },

  sendWhiteLabelMail(_, params) {
    return axios.post("/api/auth/sendwhitelabelregisteremail", params, {
      withCredentials: true,
    });
  },

  sendRegularMail(_, params) {
    return axios.post("/api/auth/sendregularcompanyregisteremail", params, {
      withCredentials: true,
    });
  },

  sendSupplierMail(_, params) {
    return axios.post("/api/auth/sendsupplierregisteremail", params, {
      withCredentials: true,
    });
  },

  sendSupplierInvite(_, params) {
    return axios.post("/api/auth/send-supplier-invite", params, {
      withCredentials: true,
    });
  },

  //#region Company Licence

  getCompanyLicence(_, params) {
    return axios.post(
      "/api/companylicence/getcompanylicencesbycompanyid",
      params,
      { withCredentials: true }
    );
  },

  updateCompanyLicence(_, params) {
    const requestBody = {
      plan_id: params.plan_id,
      updated_by: params.updated_by,
      optional_module_1_id: params.optional_module_1_id,
      optional_module_2_id: params.optional_module_2_id,
      optional_module_3_id: params.optional_module_3_id,
      optional_module_4_id: params.optional_module_4_id,
    };

    return axios.post(
      `/api/companylicence/updatecompanylicence/${params.company_licence_id}`,
      requestBody,
      { withCredentials: true }
    );
  },
  updateCompanyLicenceStatus(_, params) {
    return axios.post(
      `/api/companylicence/updatecompanylicence/${params.company_licence_id}`,
      {
        licence_status: params.licence_status,
        updated_by: params.updated_by,
      },
      { withCredentials: true }
    );
  },
  updateCompanyLicenceEndDate(_, params) {
    return axios.post(
      `/api/companylicence/updatecompanylicence/${params.company_licence_id}`,
      {
        licence_end_date: params.licence_end_date,
        updated_by: params.updated_by,
      },
      { withCredentials: true }
    );
  },

  //#endregion

  //#region Company Module

  getAppModules(_, params) {
    return axios.post("/api/appmodule/getappmodulesbyplanid", params, {
      withCredentials: true,
    });
  },

  getAllModules(_, params) {
    return axios.post("/api/appmodule/getappmodules", params, {
      withCredentials: true,
    });
  },

  getPlans(_, params) {
    return axios.post("/api/plan/getplans", params, { withCredentials: true });
  },

  //#endregion

  //#region admin panel

  updateCompanyAdminPanel(_, params) {
    return axios.post(
      `/api/company/updatecompany/${params.company_id}`,
      {
        company_id: params.company_id,
        updated_by: params.updated_by,
        company_name: params.company_name,
        company_fullname: params.company_fullname,
        adress: params.adress,
        country: params.country,
        province: params.province,
        district: params.district,
        sector_id: params.sector_id,
        currency_id: params.currency_id,
        total_employee_number: params.total_employee_number,
        website: params.website,
      }, { withCredentials: true }
    );
  },

  //#endregion

  //#region Company Profile Specific

  getFirstSection() {
    return axios.get("/api/company/companyprofile/getfirstsectioninfo", {withCredentials: true });
  },

  getSecondSection() {
    return axios.get("/api/company/companyprofile/getsecondsectioninfo", {withCredentials: true });
  },

  getAboutCompany() {
    return axios.get("/api/company/companyprofile/getaboutcompany", {withCredentials: true });
  },

  getFacilitySlotNumber() {
    return axios.get("/api/company/companyprofile/getfacilityslotnumber", {withCredentials: true });
  },

  getVisionMissionValues(_, params) {
    return axios.get(
      `/api/company/companyprofile/getvisionmissionvalues/${params.type}`, { withCredentials: true });
  },

  getCompanyPlan() {
    return axios.get(`/api/company/companyprofile/getcompanyplan`, { withCredentials: true });
  },

  getCompanyReportPublishingStatus() {
    return axios.get(`/api/company/companyprofile/getreportpublishingstatus`,{ withCredentials: true });
  },

  checkReportsPublished() {
    return axios.get(`/api/company/companyProfile/checkreportspublished`, { withCredentials: true });
  },

  updateReportsPublished(_, params) {
    return axios.post(
      `/api/company/companyprofile/updatereportspublished`,
      params,
      { withCredentials: true }
    );
  },

  updateReportLanguages(_, params) {
    return axios.post(
      `/api/company/companyprofile/updatereportlanguages`,
      params,
      { withCredentials: true }
    );
  },

  //#endregion

  //#region App Selection
  getAppSelectionInfo(_, params) {
    return axios.get(
      `/api/company/companyprofile/getappselectioninfo/${params.company_id}`,
      { withCredentials: true }
    );
  },
  //#endregion

  //#region First Section -- Location
  getCountries(_) {
    return axios.get(
      `/api/location/getcountries`,
      { withCredentials: true }
    );
  },
  
  getStatesByCountryId(_, params) {
    return axios.get(
      `/api/location/getstatesbycountryid/${params.country_id}`,
      { withCredentials: true }
    );
  },
  
  getProvincesByStateId(_, params) {
    return axios.get(
      `/api/location/getprovincesbystateid/${params.state_id}`,
      { withCredentials: true }
    );
  },
  
  getProvincesByCountryId(_, params) {
    return axios.get(
      `/api/location/getprovincesbycountryid/${params.country_id}`,
      { withCredentials: true }
    );
  },
  //#endregion
};
